


















































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class PrivacyPage extends Vue {
	/** Attributs */

	/** Méthodes */
}
